var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mailing-status"},[_c('ui-tag',{attrs:{"bgColor":_vm.mailing.getStatusBgColor(),"color":_vm.mailing.getStatusColor()}},[_vm._v("\n    "+_vm._s(_vm.mailing.getStatusLabel())+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }